import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import clsx from "clsx"
import { analytics } from "@/telemetry/amplitude"
import { toTestId } from "./testid"

const Switch = React.forwardRef<
	React.ElementRef<typeof SwitchPrimitives.Root>,
	React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
		trackingLabel: string
		trackingValue?: string
		trackingValues?: Record<string, any>
		isHighlighted?: boolean
	}
>(
	(
		{
			className,
			trackingLabel,
			trackingValue,
			trackingValues,
			onClick,
			isHighlighted,
			...props
		},
		ref,
	) => {
		return (
			<SwitchPrimitives.Root
				className={clsx(
					"peer inline-flex h-[18px] w-[34px] shrink-0 items-center rounded-full border-none transition-colors disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-accent-600 data-[state=unchecked]:bg-base-700 data-[state=checked]:hover:bg-accent-700 data-[state=unchecked]:hover:bg-base-500 dark:data-[state=unchecked]:bg-base-600",
					className,
				)}
				aria-label={trackingLabel}
				data-testid={toTestId(trackingLabel)}
				onClick={(e) => {
					onClick?.(e)
					analytics.trackEvent(
						{
							type: "click",
							label: trackingLabel,
							value: trackingValue ?? (!props.checked ? "true" : "false"),
							customProperties: trackingValues,
						},
						e.target,
					)
				}}
				{...props}
				ref={ref}
			>
				<div className="relative z-0 flex">
					<div
						className={clsx(
							isHighlighted &&
								"animate-pulse outline outline-[5px] outline-accent-500",
							"left-0 top-0 z-10 ml-px block size-[16px] rounded-full",
						)}
					></div>
					<SwitchPrimitives.Thumb
						className={clsx(
							"pointer-events-none absolute left-0 top-0 z-20 block size-[16px] flex-none rounded-full bg-base-900 shadow-lg transition-transform data-[state=checked]:translate-x-[17px] data-[state=unchecked]:translate-x-px dark:bg-base-200",
						)}
					/>
				</div>
			</SwitchPrimitives.Root>
		)
	},
)
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
